var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2498 3.38663C11.2522 3.53578 11.2981 3.68099 11.3819 3.80438C11.4657 3.92777 11.5838 4.02397 11.7216 4.08113C12.9532 4.62307 13.9948 5.52076 14.7126 6.65896C15.4304 7.79716 15.7916 9.12391 15.7498 10.4689C15.7208 12.2591 14.9818 13.9644 13.6954 15.2098C12.409 16.4551 10.6805 17.1384 8.89033 17.1094C7.10012 17.0803 5.39477 16.3413 4.14943 15.0549C2.9041 13.7685 2.22079 12.0401 2.24983 10.2499C2.25157 8.94205 2.63319 7.66289 3.34832 6.56789C4.06345 5.47289 5.08128 4.60923 6.27808 4.08188C6.41593 4.02438 6.53399 3.92789 6.61779 3.80426C6.70158 3.68062 6.74748 3.53522 6.74983 3.38588C6.75003 3.26304 6.72004 3.14203 6.66252 3.03349C6.60499 2.92495 6.52168 2.8322 6.41992 2.76339C6.31815 2.69459 6.20105 2.65183 6.07889 2.63888C5.95673 2.62593 5.83326 2.64319 5.71933 2.68913C3.9788 3.44374 2.5515 4.77514 1.67786 6.45908C0.804212 8.14301 0.537604 10.0766 0.92294 11.9341C1.30827 13.7917 2.32201 15.4596 3.79339 16.6571C5.26477 17.8546 7.10388 18.5084 9.00096 18.5084C10.898 18.5084 12.7372 17.8546 14.2085 16.6571C15.6799 15.4596 16.6936 13.7917 17.079 11.9341C17.4643 10.0766 17.1977 8.14301 16.3241 6.45908C15.4504 4.77514 14.0231 3.44374 12.2826 2.68913C12.1685 2.64269 12.0447 2.62507 11.9222 2.63782C11.7996 2.65058 11.6821 2.69331 11.5801 2.76226C11.478 2.83121 11.3944 2.92424 11.3368 3.03314C11.2793 3.14204 11.2494 3.26344 11.2498 3.38663Z",
    fill: "#177C9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75013 1.25C9.75013 0.835786 9.41434 0.5 9.00013 0.5C8.58591 0.5 8.25012 0.835786 8.25012 1.25V5.75C8.25012 6.16421 8.58591 6.5 9.00013 6.5C9.41434 6.5 9.75013 6.16421 9.75013 5.75V1.25Z",
    fill: "#177C9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_3973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.a6c98cd0694d66f1de633cad278981b0.svg";
export { ForwardRef as ReactComponent };